<template>
  <div class="hidden-md-and-up smallScreen">
    <v-app-bar elevation="0">
      <v-btn text small color @click.stop="mobileDrawer = !mobileDrawer">
        <v-icon>reorder</v-icon>
      </v-btn>
    </v-app-bar>

    <v-navigation-drawer v-model="mobileDrawer" absolute temporary>
      <v-list>
        <!-- ```{{menuItemsData}}``` -->
        <ul v-for="item in menuItemsData" :key="item.parent" class="mainMenuSmall">
          <li>
            <v-btn text @click="getSubmenu(item)" :to="item.path">{{item.parent}}</v-btn>
            <ul v-for="(data,index) in item.children" :key="index">
              <li>
                <v-btn text :to="data.link">{{data.title}}</v-btn>
              </li>
            </ul>
          </li>
        </ul>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
export default {

  data() {
    return {
      mobileDrawer: false,
      subMenuItems: [],
      menuItemsData: []
    };
  },
  mounted() {

    this.getMenu();
  },
  watch: {
    group() {
      this.mobileDrawer = false;
    }
  },
  methods: {
    getMenu() {
      this.menuItemsData = this.getMenuData();
    }
  }
};
</script>

<style>
</style>